import { sPostToEngagementTools } from "../../shared.min.js";

const openAiFile = (function () {

	const widget = document.getElementById('parking-signs-widget');
	const bannerStep = widget.querySelector('.parking-signs-widget__banner .banner-current-progress');
	const bannerText = widget.querySelector('.parking-signs-widget__banner__header__title');
	const bannerTextCMS = document.getElementById('banner-text');
	const bannerTextScreen1 = bannerTextCMS.getAttribute('data-banner-text-1');
	const bannerTextScreen2 = bannerTextCMS.getAttribute('data-banner-text-2');	
	const totalBannerSteps = 2;
	const spinner = widget.querySelector('.parking-signs-widget__response-spinner');
	const fieldGroup = widget.querySelector('#parking-signs-widget__step--1 .field-group');
	const responseDiv = widget.querySelector('#chatResponse');
	const submit = widget.querySelector('#btnSubmit');
	const fileSelector = widget.querySelector('#fileSelector');
	const fileInput = widget.querySelector('#fileUpload');
	const uploadedFileNameContainer = widget.querySelector('#uploadedFileNameContainer');
	const uploadedFileName = widget.querySelector('#uploadedFileName');
	const resetFileUpload = widget.querySelector('#resetFileUpload');
	const restartButton = widget.querySelector('#parking-btnRestart');
	const statusDiv = widget.querySelector('#status');

	let apiUrl;
	let apiSubKey;

	const init = () => {
		bannerStep.innerHTML = 1;
		bannerText.innerHTML = bannerTextScreen1;
		eventHandlers();
		calculateBannerProgress(totalBannerSteps);
		getApiDetails();
	}

	function getApiDetails() {
		const endpointSpan = document.getElementById('api-endpoint');
		apiUrl = endpointSpan ? endpointSpan.textContent : 'http://localhost:3000/query-ai/parking-signs-assistant/';
		const subKeySpan = document.getElementById('sub-key');
		apiSubKey = subKeySpan ? subKeySpan.textContent : '';
	}

	const eventHandlers = () => {
		fileSelector.addEventListener('click', (e) => {
			e.preventDefault();
			fieldGroup.classList.remove('field-group--error');
			fileInput.click();
		})

		// Event listener for the file input to handle file selection
		fileInput.addEventListener('change', () => {
			if (fileInput.files.length > 0) {
				const fileName = fileInput.files[0].name;
				uploadedFileName.innerHTML = fileName;
				uploadedFileNameContainer.classList.remove('display-none');
			} 
		});

		submit.addEventListener('click', async (event) => {
			event.preventDefault();
			// trigger error message
			if (fileInput.files.length === 0) {
				fieldGroup.classList.add('field-group--error');
				return;
			} else {
				fieldGroup.classList.remove('field-group--error');
			}

			//submit.classList.toggle('btn--loading');
			toggleStep();
			uploadMessage();
		});

		resetFileUpload.addEventListener('click', (event) => {
			event.preventDefault();
			resetDefaults();
		});

		restartButton.addEventListener('click', (event) => {
			event.preventDefault();
			toggleStep();
			resetDefaults();
			scrollToWidget();
		});
	}

	const  scrollToWidget = () => {
		const offset = 100; // Adjust for 60px above the element
		const elementPosition = widget.getBoundingClientRect().top + window.scrollY - offset;

		window.scrollTo({
			top: elementPosition,
			behavior: 'smooth' // Smooth scrolling animation
		});
    }

	const toggleStep = () => {
		const step1 = document.getElementById('parking-signs-widget__step--1');
		const step2 = document.getElementById('parking-signs-widget__step--2');
		step1.classList.toggle('display-none');
		step2.classList.toggle('display-none');
		
		bannerStep.innerHTML === "1" ? bannerStep.innerHTML = 2 : bannerStep.innerHTML = 1;
		bannerText.innerHTML ===  bannerTextScreen1 ? bannerText.innerHTML = bannerTextScreen2 : bannerText.innerHTML = bannerTextScreen1;
		calculateBannerProgress(totalBannerSteps);
	}

	const calculateBannerProgress = (totalBannerSteps) => {
		const progress = document.querySelector('.parking-signs-widget__banner__progress-bar__step'),
		//CALC WIDTH OF EACH STEP IN THE PROCESS
		stepWidth = `${(100 / totalBannerSteps) * parseInt(bannerStep.innerHTML)}%`;
		progress.style.width = stepWidth;
	}

	const resetDefaults = () => {
		uploadedFileName.innerHTML = '';
		uploadedFileNameContainer.classList.add('display-none');
		fileInput.value = '';
		responseDiv.innerHTML = '';
		statusDiv.innerHTML = '';
		spinner.classList.remove('display-none');
		bannerStep.innerHTML = 1;
		bannerText.innerHTML = bannerTextScreen1;
	}

	const extractAndFormatMessage = (messageData) => {
		
		// Check if the response is valid and has the necessary properties
		if (!messageData.messages) {
			console.error('Invalid response structure');
			return 'No message content available.';
		}

		// Extract the first message group
		const messageGroup = messageData.messages[0];

		// Extract and format the first valid message
		for (const message of messageGroup) {
			if (message.type === 'text' && message.text && message.text.value) {
				// Use Marked to convert Markdown to HTML
				return `<div id='messageResponse' tabindex='0'>${marked.parse(message.text.value)}</div>`;
			}
		}

		// If no valid message is found, return a default message
		return 'No valid message content available.';
	};


	
	const uploadMessage = async () => {
		
		
		const file = fileInput.files[0];

		if (!file) return;
		
		const formData = new FormData();
		formData.append('file', file);

		let response;

		try {
			const res = await sPostToEngagementTools(formData, apiSubKey, apiUrl, false);
			if (!res.ok) throw new Error(res.status);

			response = await res.json();
			const messageContent = extractAndFormatMessage(response);
			responseDiv.innerHTML = messageContent;
			spinner.classList.add('display-none')
			restartButton.classList.remove('display-none');
		} catch (error) {
			spinner.classList.add('display-none');
			restartButton.classList.remove('display-none');
			responseDiv.innerHTML = `<p>Error uploading image.</p>`;
			throw new Error(`HTTP Error: ${response.status}`);
		}
	}

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', () => {
	openAiFile.init();
});
